import type React from 'react'
import type { GroupBase, OptionProps } from 'react-select'
import { components as reactSelectComponents } from 'react-select'

export type DefaultSelectInputOption = Record<string, any> & {
  isExist?: boolean
}

type CustomSelectInputOption = DefaultSelectInputOption & {
  needToCreate?: boolean
}

export interface CustomReactSelectOptionProps<Option extends CustomSelectInputOption>
  extends OptionProps<Option, boolean, GroupBase<Option>> {
  texts?: { newOptionPrefix: string; [x: string]: string }
}

// need to customize the recommended option
const ReactSelectOption = reactSelectComponents.Option as unknown as React.ComponentType<
  CustomReactSelectOptionProps<any>
>

// react-select custom options
export function CustomReactSelectOption<Option extends CustomSelectInputOption>({
  children,
  texts,
  ...rest
}: CustomReactSelectOptionProps<Option>) {
  // const {
  //   data: { needToCreate },
  // } = rest
  return (
    <ReactSelectOption {...rest}>
      <div className="custom-option">
        <span {...(typeof children === 'string' ? { title: children } : {})}>{children}</span>
      </div>
    </ReactSelectOption>
  )
}
